import { createAction } from 'redux-actions';

export const ROPicklistOnClear = createAction('RO_PICKLIST_ON_CLEAR');

export const ROPicklistOnChangePage = createAction(
  'RO_PICKLIST_ON_CHANGE_PAGE'
);

export const ROPicklistOnChangeOrder = createAction(
  'RO_PICKLIST_ON_CHANGE_ORDER'
);

export const ROPicklistRemoveItem = createAction('RO_PICKLIST_REMOVE_ITEM');
